// Generated by Melange

import * as ReactRouter from "@tanstack/react-router";
import * as Caml_splice_call from "melange.js/caml_splice_call.jsx";
import * as Fx from "../fx/fx.jsx";
import * as MergeIntoMap from "../mergeIntoMap/mergeIntoMap.jsx";
import * as Subsonic__GetArtists from "../api/subsonic/getArtists.jsx";

function make(param) {
  return Fx.Monad_syntax.let$star(Fx.ask(undefined), (function (param) {
    const store = param.store;
    const state = store.getState();
    return Fx.Monad_syntax.let$star(Fx.provide(Subsonic__GetArtists.make(undefined), {
      credentials: state.auth.credentials
    }), (function (param) {
      const artists = param.index.reduce((function (acc, entry) {
        Caml_splice_call.spliceObjApply(acc, "push", [entry.artist]);
        return acc;
      }), []);
      const state = store.getState();
      const byId = MergeIntoMap.mergeIntoMap(state.artists.byId, artists, (function (x) {
        return x.id;
      }));
      const listIds = artists.map(function (artist) {
        return artist.id;
      });
      if (byId !== state.artists.byId || !ReactRouter.deepEqual(listIds, state.artists.listIds)) {
        store.setState(function (prevState) {
          const init = prevState.artists;
          return {
            albums: prevState.albums,
            artists: {
              albumIdsByArtistId: init.albumIdsByArtistId,
              artistInfoById: init.artistInfoById,
              byId: byId,
              listIds: listIds,
              similarArtistsById: init.similarArtistsById,
              topSongIdsByArtistName: init.topSongIdsByArtistName
            },
            auth: prevState.auth,
            player: prevState.player,
            songs: prevState.songs
          };
        });
      }
      return {
        TAG: /* Ok */ 0,
        _0: undefined
      };
    }));
  }));
}

export {
  make,
}
/* @tanstack/react-router Not a pure module */
